import { ref } from "vue";

const useSimpleBanner = ref(false);
const debug = ref(false);

export default function useApp() {
    return {
        useSimpleBanner,
        debug,
    };
}
